import { useEffect, useRef, useState } from 'react';

export default function CompetenciesSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const competencies = [
    {
      icon: 'ri-line-chart-line',
      title: 'Системно управление на капитала',
      description: 'Изграждане и оптимизация на инвестиционни стратегии с фокус върху дългосрочна доходност. Прилагане на количествени модели и фундаментален анализ за вземане на обосновани решения.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Контрол на рисковете',
      description: 'Професионално управление на риска с използване на съвременни методи за оценка и хеджиране. Количествен анализ на волатилността и корелациите за защита на капитала.',
    },
    {
      icon: 'ri-global-line',
      title: 'Глобална експертиза',
      description: 'Задълбочено разбиране на международните пазари и макроикономическите фактори. Опит с различни класове активи и юрисдикции за диверсификация на портфейла.',
    },
  ];

  return (
    <section
      ref={sectionRef}
      className="relative py-24 lg:py-32 bg-gradient-to-br from-[#0A1628] via-[#0D1B35] to-[#050B14]"
    >
      <div className="container mx-auto px-6 lg:px-12">
        {/* Label */}
        <div className="mb-6">
          <span className="text-sm uppercase tracking-[3px] text-[#D4AF37] font-semibold">
            Ключови компетенции
          </span>
        </div>

        {/* Title */}
        <h2 
          className={`text-4xl lg:text-5xl font-bold text-white mb-16 font-['Playfair_Display'] transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Експертиза и подход
        </h2>

        {/* Competency cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {competencies.map((item, index) => (
            <div
              key={index}
              className={`bg-white/5 backdrop-blur-lg border border-[#D4AF37] rounded-2xl p-10 transition-all duration-700 hover:bg-white/8 hover:border-[#D4AF37]/100 hover:border-2 hover:shadow-[0_0_40px_rgba(212,175,55,0.3)] cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 200}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${item.icon} text-5xl text-[#D4AF37]`}></i>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-4 font-['Playfair_Display']">
                {item.title}
              </h3>
              <p className="text-base text-[#B8C5D6] leading-relaxed font-['Inter']">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
